<template>
  <!-- Start print marker -->
  <div style="display: none;">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'StartPrint'
}
</script>

<style scoped>
/* No additional styles needed */
</style>